import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { masterRoutes } from "src/navigation/masterRoutes";

const APP_NAME = "DBHRM";

// A few top-level pages (src/App.js's own Switch, rendered before the
// "/" catch-all that hands off to DefaultLayout/AppContent + masterRoutes)
// aren't in masterRoutes at all.
const EXTRA_ROUTES = [
  { path: "/register", exact: true, name: "Register" },
  { path: "/404", exact: true, name: "Page Not Found" },
  { path: "/500", exact: true, name: "Server Error" },
];

const titledRoutes = [...masterRoutes, ...EXTRA_ROUTES];

// Sets the browser tab title per page instead of the static "DBHRM"
// public/index.html ships -- matches on the same path/exact shape
// masterRoutes already carries (every entry has a `name`), independent
// of the menu-permission filtering AppContent.js applies, so a title
// still shows on pages like /login a logged-out user can reach.
const DocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const route = titledRoutes.find((r) =>
      matchPath(location.pathname, { path: r.path, exact: r.exact })
    );
    document.title = route?.name ? `${route.name} | ${APP_NAME}` : APP_NAME;
  }, [location.pathname]);

  return null;
};

export default DocumentTitle;
